export enum GpActionType {
    FOLLOWUP = 'followup-approve-by-performer',
    UPDATE = 'update-goal-expiring-date',
    COACH = 'coach-start-new',
    CELEBRATE = 'celebrate',
    OBSERVE = 'observe',
    REVIEW = 'review',
    APPROVE = 'followup-approve-by-manager',
    UPDATE_GOAL = 'update-goal-met-value',
    UPDATE_EXPIRED = 'update-goal-expired-date',
    ASSESS_PROFICIENCY = 'assess-proficiency',
    START_DEV_PLAN = 'coach-develop',
    CHECK_IN = 'coach-check-in',
    CLOSE_OLD = 'coach-close-stale',
    CLOSE_NEW_MANAGER = 'coach-close-new-manager',
    COMPLETE = 'update-goal-complete',
    RESOLVE = 'followup-resolve',
}
